import Dialog from "componentsv2/modal/Dialog";
import CustomForm from "componentsv2/form/CustomForm";
import { useWizard } from "storev2/wizardStore";
import funcs from "tools/functions";
import proxy from "api/proxy";
import {
  MessageContainer,
  useMessage,
} from "componentsv2/experimental/Message";

function ModalReport({ layout, onClose, open }) {
  const { messages, error: setError, hide } = useMessage();
  const { reportName } = layout;

  async function onPrintReport() {
    const { record } = useWizard.getState();
    console.log("record > ", record);
    const { store } = record;
    let data = null;
    if (layout.actionReport) {
      try {
        data = await layout.actionReport(store);
      } catch (error) {
        setError(error);
        return;
      }
    } else {
      data = record.store;
    }
    const storeStd = funcs.recToTryton(data);
    const session = proxy.getSession();
    if (session?.company) {
      storeStd.company = session.company;
    }
    const { reportUrl, nameFile, error } = await proxy.report({
      report: reportName,
      data: storeStd,
      records: [],
    });
    if (error) {
      setError(error);
    } else {
      funcs.createReportLink(reportUrl, nameFile);
      onClose();
    }
  }

  const buttonPrint = {
    label: "button.print",
    name: "print",
    onClick: onPrintReport,
  };

  const buttonClose = {
    label: "button.close",
    name: "close",
    onClick: onClose,
  };

  const buttons = [buttonClose, buttonPrint];
  return (
    <Dialog
      openModal={open}
      width="h-fit"
      btnCloseActive={true}
      handleClose={onClose}
      title={reportName}
      buttons={buttons}
      size="w-screen h-3/5 md:w-3/5"
    >
      <MessageContainer messages={messages} onMessageClose={hide} />
      <CustomForm layout={layout} storeId={layout.model} />
    </Dialog>
  );
}

export default ModalReport;
